import { faSearch } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CSSProperties } from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import { GooglePlacesAutoComplete } from '~/components/forms/GooglePlacesSearchBar';
import theme from '~/styles/styledComponentsTheme';
import LSTVButton from '../LSTVButton';

const GooglePlacesAutoCompleteStyles = createGlobalStyle`
  .pac-container {
    padding: 0px !important;
    border-radius: 10px;
    box-shadow: 0px 0px 14px rgba(0, 0, 0, 0.25);
  }

  .pac-item {
    padding: 10px 29px;
    border: none;
    cursor: pointer;

    &:hover {
      background-color: ${theme.midGrey};
    }
  }

  .pac-icon {
    width: 20px;
    height: 26px;
    background-image: url('/images/icon-map-location.svg') !important;
    background-repeat: no-repeat;
    background-size: 20px 26px;
    background-position: center;
    margin-top: 4px;
  }

  /* probably breaking google's terms here ... */
  .pac-logo::after { display: none; }

  .pac-matched {
    color: ${theme.black};
    font-weight: 500;
    font-size: 18px;
  }

  .pac-item-query {
    color: ${theme.darkerGrey};
    font-weight: 500;
    font-size: 18px;
  }
`;

const Container = styled.div`
  position: relative;

  input {
    padding: 0 60px 0 15px;
    height: 51px;
    min-width: 284px;
    font-size: 20px;
    color: ${theme.black};
    background-color: ${theme.lightGrey};
    border-color: ${theme.blueGrey};
    border-radius: 8px;
    transition: all 0.1s ease;
    -webkit-appearance: none;

    @media ${theme.breakpoints.laptop} {
      min-width: 365px;
    }

    &:hover,
    &:focus {
      border-color: ${theme.darkGrey};
    }

    &::placeholder {
      color: ${theme.black};
      opacity: 1;
    }
    &::-moz-placeholder {
      color: ${theme.black};
      opacity: 1;
    }
  }
`;

const SearchButton = styled(LSTVButton)`
  width: 39px;
  height: 39px;
  background: ${(props) => props.theme.highlight_7_0};
  color: #fff;
  border-radius: 8px;
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  right: 6px;
  top: 6px;
  cursor: pointer;
`;

export const LocationSelect = ({
  placeholder,
  value,
  onChange,
  onClickSearch,
  style,
}: {
  placeholder?: string;
  value: string;
  onChange: (value: string) => void;
  onClickSearch: () => void;
  style?: CSSProperties;
}) => {
  return (
    <Container>
      <GooglePlacesAutoComplete placeholder={placeholder ?? 'Location'} {...{ value, onChange, style }} />
      {/* important to come after component so we can override global styles within */}
      <GooglePlacesAutoCompleteStyles />
      <SearchButton onClick={onClickSearch} aria-label="Search">
        <FontAwesomeIcon icon={faSearch} />
      </SearchButton>
    </Container>
  );
};
